import axios from "axios";

const API = process.env.REACT_APP_API; // Change this to your backend URL if different

export const fetchLeaderboard = async (projectId, ss) => {
  // Pass projectId as a query param. 
  // If your backend route expects /summary/:projectId, change the URL accordingly.
  
  console.log("Fetching summary for projectId:", projectId);
  const res = await axios.get(`${API}/api/summary`, {
    params: { projectId: projectId, ss:ss }
  });
  return res.data;
};

// Add this below your existing fetchLeaderboard function in api.js

// export const fetchAiInsights = async (projectId, projectData) => {
//   console.log("Fetching AI insights for projectId:", projectId);
//   const res = await axios.post(`${API}/api/ai-context`, {
//     projectId: projectId,
//     projectData: projectData
//   });
//   return res.data;
// };


// In api.js

export const fetchAiInsights = async (projectId, projectData, onChunk) => {
  console.log("Starting AI stream for projectId:", projectId);
  
  const response = await fetch(`${API}/api/ai-context`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ projectId, projectData })
  });

  if (!response.body) throw new Error("ReadableStream not supported in this browser.");

  // Attach a reader to the incoming stream
  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    // Decode the chunk of bytes into text
    const chunk = decoder.decode(value, { stream: true });
    
    // Split the chunk by newlines (SSE format)
    const lines = chunk.split('\n');
    for (const line of lines) {
      if (line.startsWith('data: ')) {
        const dataStr = line.replace('data: ', '');
        
        if (dataStr === '[DONE]') return; // Stream is finished

        try {
          const parsed = JSON.parse(dataStr);
          if (parsed.text) {
            onChunk(parsed.text); // Send the new word to React!
          }
        } catch (e) {
          console.error("Error parsing stream chunk:", e);
        }
      }
    }
  }
};

// In api.js

// export const fetchAiChat = async (projectId, messages, projectData,onChunk) => {
//   console.log("Sending chat to AI for projectId:", projectId);
//   const res = await fetch(`${API}/api/ai-chat`, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({ projectId, messages, projectData })
//   });
//   return res.data;
// };

// In api.js

export const fetchAiChat = async (projectId, messages, projectData, onChunk) => {
  console.log("Sending chat stream to AI for projectId:", projectId);
  
  const response = await fetch(`${API}/api/ai-chat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ projectId, messages, projectData }) // Send everything in the body
  });

  if (!response.body) throw new Error("ReadableStream not supported in this browser.");

  // Attach a reader to the incoming stream
  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    // Decode the chunk of bytes into text
    const chunk = decoder.decode(value, { stream: true });
    
    // Split the chunk by newlines (SSE format)
    const lines = chunk.split('\n');
    for (const line of lines) {
      if (line.startsWith('data: ')) {
        const dataStr = line.replace('data: ', '');
        
        if (dataStr === '[DONE]') return; // Stream is finished

        try {
          const parsed = JSON.parse(dataStr);
          if (parsed.text) {
            onChunk(parsed.text); // Send the text chunk to the UI
          }
        } catch (e) {
          console.error("Error parsing stream chunk:", e);
        }
      }
    }
  }
};

export const fetchEmployeeUtilization = async () => {
  console.log("Fetching employee utilization");
  const res = await axios.get(`${API}/api/utilization`);
  return res.data;
};
